module.exports = __webpack_public_path__ + "five.064b131b8ddd629a36cc.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/five/five.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/five/five.jpg
// module chunks = 0